import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { type ErrorComponentProps, useRouter } from '@tanstack/react-router';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export function RouteError({ reset }: ErrorComponentProps): ReactElement {
	const { t } = useTranslation();
	const router = useRouter();
	const queryErrorResetBoundary = useQueryErrorResetBoundary();

	function onRetry(): void {
		queryErrorResetBoundary.reset();
		reset();
		void router.invalidate();
	}

	return (
		<div className="flex h-full w-full items-center justify-center p-4">
			<div className="flex max-w-md flex-col items-center gap-4 text-center">
				<div className="flex flex-col gap-2">
					<h1 className="text-2xl font-bold">{t('RouteError.Title')}</h1>
					<p className="text-muted-foreground">{t('RouteError.Description')}</p>
				</div>
				<Button onClick={onRetry}>{t('RouteError.Retry')}</Button>
			</div>
		</div>
	);
}
